import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-a705b0e6")
const _hoisted_1 = { class: "operation-land-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "tip" }, "产品信息", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "tip" }, "问题反馈", -1)
const _hoisted_4 = {
  key: 0,
  class: "detail"
}
const _hoisted_5 = {
  key: 1,
  class: "detail-back detail"
}
const _hoisted_6 = { class: "create-time" }
const _hoisted_7 = { class: "imgbox" }
const _hoisted_8 = {
  key: 2,
  class: "bottom-btn"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode("提交")
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_stcp_h5_uploader = _resolveComponent("stcp-h5-uploader")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_van_cell_group, null, {
      default: _withCtx(() => [
        _createVNode(_component_van_field, {
          readonly: true,
          modelValue: _ctx.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.name = $event)),
          label: "产品名称"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_van_field, {
          readonly: true,
          modelValue: _ctx.croperName,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.croperName = $event)),
          label: "收购方"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_van_field, {
          readonly: true,
          modelValue: _ctx.farmer,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.farmer = $event)),
          label: "供应农户"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_van_field, {
          readonly: true,
          modelValue: _ctx.date,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.date = $event)),
          label: "收购日期"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_van_field, {
          readonly: true,
          modelValue: _ctx.order,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.order = $event)),
          label: "单据编号"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _hoisted_3,
    (_ctx.type == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_van_field, {
            modelValue: _ctx.remark,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.remark = $event)),
            rows: "1",
            autosize: "",
            type: "textarea",
            maxlength: "255",
            placeholder: "说说这框货的问题"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_stcp_h5_uploader, {
            modelValue: _ctx.imageList,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.imageList = $event)),
            multiple: "",
            "after-read": _ctx.imageUploadAfter,
            onDelete: _ctx.onDeleteImg,
            "max-count": 9,
            onPoster: _ctx.onClickImgPoster,
            class: "upload"
          }, null, 8, ["modelValue", "after-read", "onDelete", "onPoster"]),
          _createVNode(_component_van_cell_group, null, {
            default: _withCtx(() => [
              _createVNode(_component_van_field, {
                modelValue: _ctx.feedMan,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.feedMan = $event)),
                maxlength: "20",
                label: "反馈人",
                required: "",
                placeholder: "请输入"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_field, {
                modelValue: _ctx.phone,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.phone = $event)),
                maxlength: "11",
                type: "number",
                label: "联系电话",
                placeholder: "请输入",
                required: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.type == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.createTime), 1),
          _createVNode(_component_van_cell_group, null, {
            default: _withCtx(() => [
              _createVNode(_component_van_field, {
                readonly: true,
                modelValue: _ctx.feedMan,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.feedMan = $event)),
                label: "反馈人",
                requied: "",
                placeholder: "请输入"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_field, {
                readonly: true,
                modelValue: _ctx.phone,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.phone = $event)),
                type: "number",
                label: "联系电话",
                placeholder: "请输入"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_van_field, {
            modelValue: _ctx.remark,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.remark = $event)),
            rows: "1",
            autosize: "",
            type: "textarea",
            maxlength: "255",
            placeholder: "说说这框货的问题"
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageList, (item) => {
              return (_openBlock(), _createBlock(_component_van_image, {
                key: item.id,
                width: "100",
                height: "100",
                radius: "5px",
                fit: "cover",
                src: item.url+'?imageView2/1/w/200/h/200/rotate/0',
                onClick: ($event: any) => (_ctx.onPreviewImg(item,_ctx.imageList))
              }, null, 8, ["src", "onClick"]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.type == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_van_button, {
            round: "",
            block: "",
            type: "primary",
            onClick: _ctx.postInfo,
            "native-type": "submit"
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true)
  ]))
}